<template>
  <div class="home">
    <UnderConstruction />
  </div>
</template>

<script>
import UnderConstruction from "@/components/UnderConstruction";
export default {
  name: "Home",
  components: {
    UnderConstruction
  }
};
</script>
